
                    <div class="side-bar section-padding pb-0 mb-md-40 mt-3">
                        <div class="main-box padding-20 trending-blog-cat mb-xl-20">
                            <h4 class="text-light-black">Categories</h4>
                            <ul>
                                <li class="pb-xl-20 u-line mb-xl-20"
                                (click)="selectCategory('burgers')"
                                [ngClass]="{ 'active-category': selectedCategory === 'burgers' }">
                            
                                <a class="text-light-black fw-600">Burgers</a>
                            </li>
                            
                        
                                <li class="pb-xl-20 u-line mb-xl-20" [ngClass]="{ 'active-category': selectedCategory === 'tasty-teasers' }"
                                    (click)="selectCategory('tasty-teasers')">
                                    <a class="text-light-black fw-600">Tasty Teasers</a>
                                </li>
                        
                                <li class="pb-xl-20 u-line mb-xl-20" [ngClass]="{ 'active-category': selectedCategory === 'junior' }"
                                    (click)="selectCategory('junior')">
                                    <a class="text-light-black fw-600">Junior Nibblers</a>
                                </li>
                        
                                <li class="pb-xl-20 u-line mb-xl-20"[ngClass]="{ 'active-category': selectedCategory === 'sides' }"
                                    (click)="selectCategory('sides')">
                                    <a class="text-light-black fw-600">Sides & Sauces</a>
                                </li>
                        
                                <li class="pb-xl-20 u-line mb-xl-20"  [ngClass]="{ 'active-category': selectedCategory === 'milkshakes' }"
                                    (click)="selectCategory('milkshakes')">
                                    <a class="text-light-black fw-600">Milk Shakes</a>
                                </li>
                        
                                <li class="pb-xl-20 u-line mb-xl-20"[ngClass]="{ 'active-category': selectedCategory === 'mocktails' }"
                                    (click)="selectCategory('mocktails')">
                                    <a class="text-light-black fw-600">Mocktails</a>
                                </li>
                        
                                <li class="pb-xl-20 u-line mb-xl-20"[ngClass]="{ 'active-category': selectedCategory === 'cocktails' }"
                                    (click)="selectCategory('cocktails')">
                                    <a class="text-light-black fw-600">Cocktails</a>
                                </li>
                        
                                <li class="pb-xl-20 u-line mb-xl-20"[ngClass]="{ 'active-category': selectedCategory === 'thirst-busters' }"
                                    (click)="selectCategory('thirst-busters')">
                                    <a class="text-light-black fw-600">Thirst Busters</a>
                                </li>
                        
                                <li class="pb-xl-20 u-line mb-xl-20"[ngClass]="{ 'active-category': selectedCategory === 'frozen-yoghurt' }"
                                    (click)="selectCategory('frozen-yoghurt')">
                                    <a class="text-light-black fw-600">Frozen Yoghurt</a>
                                </li>
                            </ul>
                        </div>
                        
                    </div>
               